module.exports = __webpack_public_path__ + "img/CplusLogo.41ef9d40.png";